import type { OwnerType } from '../models/enums';
import type { ContractType } from '@paid-ui/enums/contract';

import { useSearchParams } from 'next/navigation';

/**
 * Get search params for invited sign up
 */
export function useInvitationSearchParams() {
  const urlSearchParams = useSearchParams();
  const dialog = urlSearchParams.get('dialog') || 'complete-contract';
  const contractType = urlSearchParams.get('contractType')?.toUpperCase() as ContractType | null;
  const contractId = urlSearchParams.get('contractId');
  const groupId = urlSearchParams.get('groupId');
  const partyId = urlSearchParams.get('partyId');
  const partyType = urlSearchParams.get('partyType') as OwnerType | null;
  const email = urlSearchParams.get('email');
  const token = urlSearchParams.get('token');

  return {
    dialog,
    contractType,
    contractId,
    groupId,
    email,
    token,
    partyId,
    partyType,
  };
}
